import ModularPageComponentWrapper from "./ModularPageComponentWrapper";
export default ModularPageComponentWrapper;
